import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { host } from "../../config/Config";
import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';

export const HaircutDetails = () => {
  const { id } = useParams();
  const [haircut, setHaircut] = React.useState(null);
  const [newHaircut, setNewHaircut] = React.useState("");
  const [newPrice, setNewPrice] = React.useState("");
  const [successMessage, setSuccessMessage] = React.useState(null);
  const navigate = useNavigate();
  const [openDialog, setOpenDialog] = React.useState(false); // State to control the Dialog visibility

  React.useEffect(() => {
    const fetchHaircut = async () => {
      try {
        const token = localStorage.getItem("jwt-vlada");
        const response = await fetch(`${host}/api/v1/haircuts/${id}`, {
          method: "GET",
          headers: {
            "Authorization": `Bearer ${token}`,
            "Content-Type": "application/json"
          }
        });

        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }

        const data = await response.json();
        setHaircut(data);
        setNewHaircut(data.name); // Initialize with fetched data
        setNewPrice(data.price);   // Initialize with fetched data
      } catch (error) {
        navigate("/admin")
      }
    };

    fetchHaircut();
  }, [id]);

  const handleDelete = async () => {
    try {
      const token = localStorage.getItem("jwt-vlada");
      const response = await fetch(`${host}/api/v1/haircuts/${id}`, {
        method: "DELETE",
        headers: {
          "Authorization": `Bearer ${token}`,
          "Content-Type": "application/json"
        }
      });

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      // Close the dialog and navigate back to the main page after successful deletion
      setOpenDialog(false);
      setSuccessMessage(true); // Show success message after update

      setTimeout(() => {
        setSuccessMessage(null);
        navigate("/admin-haircuts");
      }, 2000);
    } catch (error) {
      console.error("Error deleting haircut:", error);
    }
  };

  const handleSaveChanges = async () => {
    console.log(newPrice);
    if (newPrice === "" || newHaircut.trim().length === 0) {
      return;
    }
    try {
      const token = localStorage.getItem("jwt-vlada");
      const response = await fetch(`${host}/api/v1/haircuts/${id}`, {
        method: "PUT",
        headers: {
          "Authorization": `Bearer ${token}`,
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          name: newHaircut,
          price: parseInt(newPrice, 10)
        })
      });

      if (!response.ok) {
        throw new Error(`Error updating haircut: ${response.status}`);
      }

      setSuccessMessage(true); // Show success message after update

      setTimeout(() => {
        setSuccessMessage(null);
      }, 2000);
    } catch (error) {
      console.error("Error saving haircut details:", error);
      setSuccessMessage(false);
      setTimeout(() => {
        setSuccessMessage(null);
      }, 2000);
    }
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
  };

  const handlePocetna = () => {
    navigate("/admin");
  };

  if (!haircut) {
    navigate("/admin");
  }

  return (
    <div className="barber-zajednica-admin-page">
      <div className="barber-zajednica-admin-background"></div>

      <h2 style={{marginTop: "60px", color:"#737373"}}>Naziv usluge</h2>
      <input
        style={{marginTop: "20px", width: "80%", textAlign:"center", padding: "0"}}
        type="text"
        value={newHaircut} // Now using state
        className="barber-zajednica-input-password"
        onChange={(e) => setNewHaircut(e.target.value)} // Update state
      />

      <h2 style={{marginTop: "50px", color: "#737373"}}>Cena usluge</h2>
      <input
        style={{width: "25%", textAlign:"center", padding: "0"}}
        type="number"
        value={newPrice} // Now using state
        className="barber-zajednica-input-password"
        onChange={(e) => setNewPrice(e.target.value)} // Update state
      />

      {successMessage && <h3 style={{marginTop: "60px", marginBottom:"-30px"}}>Operacija uspešna</h3>}
      {successMessage === false && <h3 style={{marginTop: "60px", marginBottom:"-30px"}}>Došlo je do greške</h3>}

      <button 
        onClick={handleSaveChanges}
        className="barber-zajednica-login-button-user" 
        style={{marginTop: "70px"}}
      >
        Sačuvaj izmene
      </button>

      <button 
        onClick={() => setOpenDialog(true)} // Open confirmation dialog
        className="barber-zajednica-login-button-user" 
        style={{ marginTop: "30px", marginBottom: "0px", zIndex: "1000" }}>
        Obriši uslugu
      </button>

      <button 
        onClick={handlePocetna}
        className="barber-zajednica-login-button-user"  
        style={{ marginTop: "30px", marginBottom: "0px", zIndex: "1000" }}>
        Nazad na Profil
      </button>

      <Dialog
        open={openDialog}
        onClose={handleCloseDialog}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{"Da li ste sigurni da želite da obrišete ovu uslugu ?"}</DialogTitle>
        <DialogContent>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseDialog} color="primary">
            Ne
          </Button>
          <Button onClick={handleDelete} color="secondary">
            Da
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};
